module.exports = __webpack_public_path__ + "media/images/small-arrow-3765953b0ac6a34a1c3970b61f6538f3.svg";